export class Zone {
    id: string;
    displayId: string;
}
